import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	plans: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	plans: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.plans.plans',
		defaultMessage: 'Plans',
		description: 'Section title for plans',
	},
});
